import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IAlertDialogData {
  title: string;
  message: string;
  okButtonText: string;
  okButtonColor: string;
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css'],
  standalone: false
})
export class AlertDialogComponent {
  dialogRef = inject<MatDialogRef<AlertDialogComponent>>(MatDialogRef);
  data = inject<IAlertDialogData>(MAT_DIALOG_DATA);


  okButtonText: string;
  okButtonColor: string;

  constructor() {
    const data = this.data;

    this.okButtonText = data.okButtonText || 'OK';
    this.okButtonColor = data.okButtonColor || 'primary';
  }
}
